import { useEffect } from 'react';
import { useMapController } from '../map/MapShell.js';
import { useThemeStore } from '../../app/themeStore.js';
import { usePredictorStore, PREDICTOR_MINUTES } from './predictorStore.js';

/** Drives the course-predictor vector on the map from the app-wide setting. */
export function PredictorLayer(): null {
  const controller = useMapController();
  const mode = usePredictorStore((s) => s.mode);
  const theme = useThemeStore((s) => s.theme); // re-tint on day/night

  useEffect(() => {
    if (!controller) return;
    controller.setPredictorMinutes(PREDICTOR_MINUTES[mode]);
    return () => controller.setPredictorMinutes(0);
  }, [controller, mode, theme]);

  return null;
}
